import apiService from "../../services/apiService";

export default {
  name: "Footer",
  data: () => {
    return {
      footer: {}
    };
  },
  async created() {
    this.footer = await apiService.getFooter();
  }
}